module.exports = __webpack_public_path__ + "img/new_head_img.b5f6db1c.png";